import {FeatureTeamItemMobile} from "./feature-team-item-mobile";
import services from "../../../../libs/services";
import EmitEvent, {HT_RESIZE, PAGE_ENTER, PAGE_LOADED, SMOOTH_SCROLLING} from "../../../../libs/emit-event";
import {MathMap} from "../../../../libs/math-utils";

export class FeatureTeamsMobile {
    constructor() {
        this.DOM = {main: document.querySelector('.js-featureTeams')};
        if (!this.DOM.main) return;

        this.DOM.inner = this.DOM.main.querySelector('.js-featureTeams_inner');
        this.DOM.wrap = this.DOM.main.querySelector('.js-featureTeams_wrap');
        this.teams = [];

        this.active = 0;
        this.propWrap = {};

        this.handleScrolling = this.handleScrolling.bind(this);
        this.getProp = this.getProp.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {
        this.DOM.main.querySelectorAll('.js-featureTeamsItem').forEach(item => {
            this.teams.push(new FeatureTeamItemMobile({
                el: item
            }));
        });
    }

    getProp() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const reactInner = this.DOM.inner.getBoundingClientRect();
        const {top} = this.DOM.main.getBoundingClientRect();
        this.prop = {
            top: top + scrollTop,
            innerHeight: reactInner.height
        }

        this.prop.height = this.teams.length * .9 * services.winSize.height;
        this.DOM.main.style.height = `${this.prop.height}px`;
        this.DOM.inner.style.top = `${(services.winSize.height - reactInner.height) / 2}px`;

    }

    handleScrolling({instance}) {
        if (this.teams.length && this.prop) {

            const disTop = (instance + this.prop.innerHeight - this.prop.top);
            if (disTop < 0) return;

            const active = Math.min(Math.round(MathMap(Math.abs(disTop), 0, (this.prop.height - this.prop.innerHeight / 2), 0, (this.teams.length - 1))), (this.teams.length - 1));

            if (this.active > active) {
                this.prevTeam(active);
            } else if (this.active < active) {
                this.nextTeam(active);
            }

            this.active = active;
        }
    }

    animationRun(active) {
        this.teams[active].animationIn((this.active < active));
    }

    nextTeam(active) {
        this.animationRun(active);
        this.teams[this.active].animationTop();
    }

    prevTeam(active) {
        this.animationRun(active);
        this.teams[this.active].animationBottom();
    }

    pageEnter() {
        this.getProp();
        this.teams[0].animationIn();
    }

    pageResize() {
        this.getProp()
    }

    bindEvent() {
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
        EmitEvent.on(PAGE_LOADED, this.getProp);
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(SMOOTH_SCROLLING, this.handleScrolling);
    }

    removeEvent() {
        if (this.teams) {
            this.teams.forEach(item => {
                item.removeEvent();
            });
        }

        EmitEvent.off(SMOOTH_SCROLLING, this.handleScrolling);
        EmitEvent.off(PAGE_LOADED, this.getProp);
        EmitEvent.off(PAGE_ENTER, this.pageEnter);
        EmitEvent.off(HT_RESIZE, this.pageResize);
    }
}